<template>
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_15458_30691"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="49"
      height="49"
    >
      <path
        d="M48.7729 0.587494H0.093689V48.4125H48.7729V0.587494Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_15458_30691)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.4333 48.4125C11.0123 48.4125 0.093689 37.6853 0.093689 24.5001C0.093689 11.3146 11.0123 0.587494 24.4333 0.587494C37.8541 0.587494 48.7729 11.3146 48.7729 24.5001C48.7729 37.6853 37.8541 48.4125 24.4333 48.4125ZM28.5529 15.2509H14.7975L12.7103 18.546H26.4501L28.5529 15.2509ZM31.364 15.2823L22.955 28.4372H13.6274L15.7793 25.1392H21.3699L23.5055 21.8428H10.5811L8.44595 25.1392H11.5077L7.25967 31.7238H24.9881L31.5362 21.5783L33.9238 25.1392H31.7709L29.7321 28.4372H36.1072L38.3209 31.7238H42.3876L31.364 15.2823Z"
        fill="white"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
